<template>
  <div class="login-card__reset-password-card">
    <div class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.password_reset.header') }}</h1>
      <p class="login-card__title-desc">{{ trans.get('auth.card.password_reset.subheader') }}</p>
    </div>
    <div>
      <p class="text-success" v-if="emailSent">{{ trans.get('auth.card.password_reset.email_successfully_sent') }}</p>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <div class="row">
          <div class="col-12">
            <validation-provider name="email" v-slot="{ errors }" mode="eager">
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
            <validation-provider name="phone" v-slot="{ errors }" mode="eager">
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-row">
            <div class="form-group col-12">
              <validation-provider name="login" rules="required" v-slot="{ errors }" mode="eager">
                <label for="login"></label>
                <input type="text" id="login" class="input-text input-text__underline" v-model="resetData.login" :placeholder="trans.get('auth.card.fields.login')">
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <button type="submit" class="button button__fill button--w-100 mt-5 ">{{ trans.get('auth.card.buttons.send') }}</button>
        </form>
      </validation-observer>
      <button type="button" class="button button__link button__link--underline mt-3" @click="swapComponent('auth-login-card')">{{ trans.get('auth.card.buttons.back') }}</button>
    </div>
  </div>
</template>
<script>

export default {
  props: ['swapComponent', 'form'],
  data: () => ({
    resetData: {
      login: '',
    },
    emailSent: false,
  }),
  methods: {
    onSubmit() {
      const self = this;

      if (!this.isEmail(this.resetData.login) && !this.resetData.login.includes('+4')) {
        self.$refs.form.setErrors({ 'login': this.trans.get('auth.phone_need_prefix') });
        return false;
      }

      axios
        .post(zRoute('password.token'), this.resetData)
        .then(function (response) {
          if (response.data.login === 'email') {
            self.emailSent = true;
          } else if (response.data.login === 'phone') {
            self.form.phone = self.resetData.login;
            self.swapComponent('auth-reset-password-phone-code-card', self.form);
          }
        }, function (error) {
          self.emailSent = false;
          if (error.response.status === 422) {
            self.$refs.form.setErrors(error.response.data.errors);
          }
        });
    },
    isEmail(login) {
      var re = /\S+@\S+\.\S+/;
      return re.test(login);
    }
  },
  activated() {
    if (this.form.email) {
      this.resetData.login = `${this.form.email}`;
    }

    this.emailSent = false;
  }
};
</script>
<style scoped>
</style>
